import { FC, useState } from 'react';
import { get } from 'lodash';
import { Button } from '@packages/utils';
import { useTheme } from 'styled-components';
import { EIconNames, Icon } from 'components/Base/Icon';
import {
  useShowToastNotification,
  ENotificationType,
} from 'components/Base/Notification';
import { Modal } from 'components/Base/Modal';
import ConfirmModalBody from 'components/Shared/ConfirmModalBody';
import { useMoveActionMutation } from 'redux/apiSlice/registrants.slice';
import { TMoveActionProps } from './MoveAction.types';

const MoveAction: FC<TMoveActionProps> = ({
  registrantId,
  workshopClassId,
  workshopId,
}) => {
  const theme = useTheme();
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);

  const [moveAction, { isLoading }] = useMoveActionMutation();
  const { showToastNotification } = useShowToastNotification();
  const handleCLoseConfirmModal = () => {
    setOpenConfirmModal(false);
  };

  const handleSubmit = async () => {
    try {
      await moveAction({
        registrantId,
        workshopClassId,
        workshopId,
      }).unwrap();
      showToastNotification({
        message: 'Registrant has been successfully moved',
        type: ENotificationType.SUCCESS,
      });
    } catch (e) {
      const message = get(e, 'data.message');
      showToastNotification({
        message,
        type: ENotificationType.ERROR,
      });
    }
    handleCLoseConfirmModal();
  };

  return (
    <>
      <Button
        icon={
          <Icon
            alt="move"
            icon={EIconNames.RIGHT_ARROW}
            size={14}
            className="pointer"
            color={theme.colorErrorDefault}
          />
        }
        onClick={() => setOpenConfirmModal(true)}
        tooltip="Move to Registrants"
        color="primary"
        shape="circle"
        size="middle"
      />

      {openConfirmModal && (
        <Modal
          title="Move to Registrants"
          open={openConfirmModal}
          onCancel={handleCLoseConfirmModal}
          onOk={handleSubmit}
          okText="Move"
          cancelText="Cancel"
          confirmLoading={isLoading}
        >
          <ConfirmModalBody description="Are you sure you want to move this registrant from the Waitlist to the Registrants list?" />
        </Modal>
      )}
    </>
  );
};

export default MoveAction;
